import Svg, { SvgProps, Path } from 'react-native-svg';

const VoucherIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M28 12.184V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v5.184c1.163.413 2 1.512 2 2.816s-.837 2.403-2 2.816V23a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2v-5.184c-1.163-.413-2-1.512-2-2.816s.837-2.403 2-2.816zm-7.448 1.777-2.902 2.16 1.078 3.453a.507.507 0 0 1-.777.564L15 18.046l-2.951 2.092a.507.507 0 0 1-.777-.564l1.078-3.453-2.902-2.16a.507.507 0 0 1 .297-.913l3.617-.042 1.158-3.427a.507.507 0 0 1 .96 0l1.158 3.427 3.617.042a.507.507 0 0 1 .297.913z" />
  </Svg>
);

export default VoucherIcon;
